import { OrderVm } from './order.vm';

export class GetOrderVm extends OrderVm {}
